import { createSelector } from 'reselect';
import { ListingDataRec } from '@/data/data-records';
import { rentalTypes } from '@/data/data-selectors';

// if component asks for data and it doesn't exists, a fetch side-effect is assumed
const NO_LISTING_DATA_REC = new ListingDataRec();

export const hostList = (state) => state.data.hostList;

export const ownerList = (state) => state.data.ownerList;

export const numberOfProperties = (state) => state.data.propertyList.length;

export const listingData = (state, regType) =>
  state.data.listingsData.get(regType) || NO_LISTING_DATA_REC;

export const allData = (state) => state.data;

export const availableListingOptions = (state) => state.data.stats?.listings;

export const navOptions = createSelector(
  availableListingOptions,
  (listingOpts) => listingOpts.map((opt) => ({ eventKey: opt.regType, ...opt }))
);

export const keyMappings = createSelector(
  rentalTypes,
  (rentalTypeMappings) => ({
    rentalType: rentalTypeMappings,
  })
);

export const isLicensingEnabled = createSelector(
  availableListingOptions,
  (listingOpts) => listingOpts.some((opt) => opt.configType === 'str')
);
